module.exports = __webpack_public_path__ + "static/media/RI.90424237.jpg";